import { z } from 'zod';
import * as directoryScheme from './directoryScheme';

export const nameHelper =
  'Contractor name is required. It must have at least 2 characters, max 300 characters, no special characters allowed';
export const nameSchema = directoryScheme.createNameSchema({
  name: 'Contractor Name',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

export const contractorSchema = z.object({
  id: directoryScheme.idSchema,
  name: nameSchema,
});

export const contractorPartialSchema = contractorSchema.partial();
